import api from './api';

// Salary Structure endpoints
export const fetchSalaryStructures = async (params = {}) => {
  const res = await api.get('/admin/employees/salary/structures/', { params });
  return res.data;
};

export const createSalaryStructure = async (data) => {
  const res = await api.post('/admin/employees/salary/structures/', data);
  return res.data;
};

export const updateSalaryStructure = async (id, data) => {
  const res = await api.patch(`/admin/employees/salary/structures/${id}/`, data);
  return res.data;
};

export const deleteSalaryStructure = async (id) => {
  const res = await api.delete(`/admin/employees/salary/structures/${id}/`);
  return res.data;
};

export const getEmployeeSalary = async (employeeId) => {
  const res = await api.get('/admin/employees/salary/structures/employee-salary/', { params: { employee_id: employeeId } });
  return res.data;
};

// Tax Configuration endpoints
export const fetchTaxConfigurations = async (params = {}) => {
  const res = await api.get('/admin/employees/salary/tax/configurations/', { params });
  return res.data;
};

export const createTaxConfiguration = async (data) => {
  const res = await api.post('/admin/employees/salary/tax/configurations/', data);
  return res.data;
};

export const updateTaxConfiguration = async (id, data) => {
  const res = await api.patch(`/admin/employees/salary/tax/configurations/${id}/`, data);
  return res.data;
};

export const deleteTaxConfiguration = async (id) => {
  const res = await api.delete(`/admin/employees/salary/tax/configurations/${id}/`);
  return res.data;
};

// Tax Bracket endpoints
export const fetchTaxBrackets = async (params = {}) => {
  const res = await api.get('/admin/employees/salary/tax/brackets/', { params });
  return res.data;
};

export const createTaxBracket = async (data) => {
  const res = await api.post('/admin/employees/salary/tax/brackets/', data);
  return res.data;
};

export const updateTaxBracket = async (id, data) => {
  const res = await api.patch(`/admin/employees/salary/tax/brackets/${id}/`, data);
  return res.data;
};

export const deleteTaxBracket = async (id) => {
  const res = await api.delete(`/admin/employees/salary/tax/brackets/${id}/`);
  return res.data;
};

export const calculateTax = async (data) => {
  const res = await api.post('/admin/employees/salary/tax/calculate/', data);
  return res.data;
};

// Benefit Type endpoints
export const fetchBenefitTypes = async (params = {}) => {
  const res = await api.get('/admin/employees/salary/benefit-types/', { params });
  return res.data;
};

export const createBenefitType = async (data) => {
  const res = await api.post('/admin/employees/salary/benefit-types/', data);
  return res.data;
};

export const updateBenefitType = async (id, data) => {
  const res = await api.patch(`/admin/employees/salary/benefit-types/${id}/`, data);
  return res.data;
};

export const deleteBenefitType = async (id) => {
  const res = await api.delete(`/admin/employees/salary/benefit-types/${id}/`);
  return res.data;
};

// Employee Benefit endpoints
export const fetchEmployeeBenefits = async (params = {}) => {
  const res = await api.get('/admin/employees/salary/employee-benefits/', { params });
  return res.data;
};

export const createEmployeeBenefit = async (data) => {
  const res = await api.post('/admin/employees/salary/employee-benefits/', data);
  return res.data;
};

export const updateEmployeeBenefit = async (id, data) => {
  const res = await api.patch(`/admin/employees/salary/employee-benefits/${id}/`, data);
  return res.data;
};

export const deleteEmployeeBenefit = async (id) => {
  const res = await api.delete(`/admin/employees/salary/employee-benefits/${id}/`);
  return res.data;
};

// Bonus endpoints
export const fetchBonuses = async (params = {}) => {
  const res = await api.get('/admin/employees/salary/bonuses/', { params });
  return res.data;
};

export const createBonus = async (data) => {
  const res = await api.post('/admin/employees/salary/bonuses/', data);
  return res.data;
};

export const updateBonus = async (id, data) => {
  const res = await api.patch(`/admin/employees/salary/bonuses/${id}/`, data);
  return res.data;
};

export const approveBonusByManager = async (id) => {
  const res = await api.post(`/admin/employees/salary/bonuses/${id}/approve-manager/`);
  return res.data;
};

export const approveBonusByHR = async (id) => {
  const res = await api.post(`/admin/employees/salary/bonuses/${id}/approve-hr/`);
  return res.data;
};

export const approveBonusByFinance = async (id) => {
  const res = await api.post(`/admin/employees/salary/bonuses/${id}/approve-finance/`);
  return res.data;
};

export const approveBonusByGM = async (id) => {
  const res = await api.post(`/admin/employees/salary/bonuses/${id}/approve-gm/`);
  return res.data;
};

export const markBonusPaid = async (id) => {
  const res = await api.post(`/admin/employees/salary/bonuses/${id}/mark-paid/`);
  return res.data;
};

export const cancelBonus = async (id) => {
  const res = await api.post(`/admin/employees/salary/bonuses/${id}/cancel/`);
  return res.data;
};

// Commission endpoints
export const fetchCommissions = async (params = {}) => {
  const res = await api.get('/admin/employees/salary/commissions/', { params });
  return res.data;
};

export const createCommission = async (data) => {
  const res = await api.post('/admin/employees/salary/commissions/', data);
  return res.data;
};

export const updateCommission = async (id, data) => {
  const res = await api.patch(`/admin/employees/salary/commissions/${id}/`, data);
  return res.data;
};

export const approveCommissionByManager = async (id) => {
  const res = await api.post(`/admin/employees/salary/commissions/${id}/approve-manager/`);
  return res.data;
};

export const approveCommissionByHR = async (id) => {
  const res = await api.post(`/admin/employees/salary/commissions/${id}/approve-hr/`);
  return res.data;
};

export const approveCommissionByFinance = async (id) => {
  const res = await api.post(`/admin/employees/salary/commissions/${id}/approve-finance/`);
  return res.data;
};

export const approveCommissionByGM = async (id) => {
  const res = await api.post(`/admin/employees/salary/commissions/${id}/approve-gm/`);
  return res.data;
};

export const markCommissionPaid = async (id) => {
  const res = await api.post(`/admin/employees/salary/commissions/${id}/mark-paid/`);
  return res.data;
};

export const cancelCommission = async (id) => {
  const res = await api.post(`/admin/employees/salary/commissions/${id}/cancel/`);
  return res.data;
};

// Payroll endpoints
export const fetchPayrolls = async (params = {}) => {
  const res = await api.get('/admin/employees/salary/payrolls/', { params });
  return res.data;
};

export const generatePayroll = async (data) => {
  const res = await api.post('/admin/employees/salary/payrolls/generate/', data);
  return res.data;
};

export const getPayroll = async (id) => {
  const res = await api.get(`/admin/employees/salary/payrolls/${id}/`);
  return res.data;
};

export const getPayrollDetails = async (id) => {
  const res = await api.get(`/admin/employees/salary/payrolls/${id}/details/`);
  return res.data;
};

export const approvePayrollByManager = async (id) => {
  const res = await api.post(`/admin/employees/salary/payrolls/${id}/approve-manager/`);
  return res.data;
};

export const approvePayrollByHR = async (id) => {
  const res = await api.post(`/admin/employees/salary/payrolls/${id}/approve-hr/`);
  return res.data;
};

export const approvePayrollByFinance = async (id) => {
  const res = await api.post(`/admin/employees/salary/payrolls/${id}/approve-finance/`);
  return res.data;
};

export const approvePayrollByGM = async (id) => {
  const res = await api.post(`/admin/employees/salary/payrolls/${id}/approve-gm/`);
  return res.data;
};

export const markPayrollPaid = async (id, data) => {
  const res = await api.post(`/admin/employees/salary/payrolls/${id}/mark-paid/`, data);
  return res.data;
};

export const cancelPayroll = async (id) => {
  const res = await api.post(`/admin/employees/salary/payrolls/${id}/cancel/`);
  return res.data;
};

export const getEmployeePayrollHistory = async (employeeId) => {
  const res = await api.get('/admin/employees/salary/payrolls/employee-history/', { params: { employee_id: employeeId } });
  return res.data;
};

// Deduction endpoints
export const fetchDeductions = async (params = {}) => {
  const res = await api.get('/admin/employees/salary/deductions/', { params });
  return res.data;
};

export const createDeduction = async (data) => {
  const res = await api.post('/admin/employees/salary/deductions/', data);
  return res.data;
};

export const updateDeduction = async (id, data) => {
  const res = await api.patch(`/admin/employees/salary/deductions/${id}/`, data);
  return res.data;
};

export const deleteDeduction = async (id) => {
  const res = await api.delete(`/admin/employees/salary/deductions/${id}/`);
  return res.data;
};


